/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     免登录白名单
  +--------------------------------------------------------------------------------------
*/

const whiteList = [
  '/login',
  '/register',
  '/password',
  '/refresh',
  '/error404'
]

export default whiteList
